import { useSearchParams } from 'react-router-dom';

import {
  COURT_CASES_V2_ROUTES,
  LEGAL_INTELLIGENCE_ROUTES,
} from '../../../../constants';

import {
  BreadcrumbChevron,
  BreadcrumbCurrent,
  BreadcrumbLink,
  BreadcrumbRow,
} from './components';

import type { DocketDetailHeaderSection } from '../types';

export function ReportBreadcrumbs({
  header,
}: {
  header: DocketDetailHeaderSection;
}) {
  const [searchParams] = useSearchParams();
  const returnTo =
    searchParams.get('returnTo') ?? COURT_CASES_V2_ROUTES.CLASS_ACTION_LAWSUITS;

  return (
    <BreadcrumbRow aria-label="Breadcrumb">
      <BreadcrumbLink to={LEGAL_INTELLIGENCE_ROUTES.BASE}>
        Legal Intelligence
      </BreadcrumbLink>
      <BreadcrumbChevron aria-hidden />
      <BreadcrumbLink to={returnTo}>Class Actions</BreadcrumbLink>
      <BreadcrumbChevron aria-hidden />
      <BreadcrumbCurrent title={header.case_title} aria-current="page">
        {header.case_title || 'Report'}
      </BreadcrumbCurrent>
    </BreadcrumbRow>
  );
}
